import React, { Component } from "react";
import classNames from "classnames";

class Tabs extends Component {
    constructor() {
        super();

        this.state = {
            isCurrent: 0,
            counter: 0
        };

        this.setCurrent = this.setCurrent.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialCurrentIndex !== this.props.initialCurrentIndex) {
            this.setState({
                isCurrent: this.props.initialCurrentIndex,
                counter: this.props.initialCurrentIndex
            });
        }
    }

    setCurrent(tab, counter) {
        this.setState({
            isCurrent: tab,
            counter: counter
        });
    }

    onKeyDown(e) {
        const tabs = document.querySelectorAll('[role="tab"]');

        let tabFocus = this.state.isCurrent;
        let counter = this.state.counter;

        const availableFocusIndex = [];

        tabs.forEach((item, index) => {
            if (!item.disabled) {
                availableFocusIndex.push(index);
            }
        });

        if (e.key === "ArrowRight" || e.key === "ArrowLeft" || e.key === "ArrowUp" || e.key === "ArrowDown") {
            tabs[tabFocus].setAttribute("tabindex", -1);
            // Move right
            if (e.key === "ArrowRight" || e.key === "ArrowUp") {
                counter++;
                tabFocus = availableFocusIndex[counter];
                // If we're at the end, go to the start
                if (counter >= availableFocusIndex.length) {
                    tabFocus = 0;
                    counter = 0;
                }
                // Move left
            } else if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
                counter--;
                tabFocus = availableFocusIndex[counter];
                // If we're at the start, move to the end
                if (counter < 0) {
                    tabFocus = tabs.length - 1;
                    counter = availableFocusIndex.length - 1;
                }
            }

            tabs[tabFocus].setAttribute("tabindex", 0);
            tabs[tabFocus].focus();
            this.setCurrent(tabFocus, counter);
        }
    }

    componentDidMount() {
        const tabList = document.querySelector('[role="tablist"]');
        tabList.addEventListener("keydown", this.onKeyDown, false);
    }

    componentWillUnmount() {
        const tabList = document.querySelector('[role="tablist"]');
        tabList.removeEventListener("keydown", this.onKeyDown, false);
    }

    render() {
        const childTabs = this.props.children.filter(child => {
            return child != false;
        });

        return (
            <div role="tablist" className="tabs-container">
                <div className="tabs__menu">
                    <div className="tabs__menu-inner">
                        {childTabs.map((child, index) => {
                            const tabClasses = classNames({
                                tabs__menu__tab: true,
                                active: this.state.isCurrent == index,
                                disabled: child.props.isDisabled
                            });
                            return (
                                <button
                                    role="tab"
                                    aria-selected={this.state.isCurrent == index}
                                    aria-controls={"panel"}
                                    key={index}
                                    disabled={child.props.isDisabled}
                                    id={`tab-${child.props.label}`}
                                    className={tabClasses}
                                    onClick={child.props.isDisabled ? null : () => this.setCurrent(index)}
                                >
                                    {child.props.label}
                                    {child.props.labelCount && <span>{child.props.labelCount}</span>}
                                </button>
                            );
                        })}
                    </div>
                </div>

                <div className="tabs__content">{childTabs[this.state.isCurrent]}</div>
            </div>
        );
    }
}

export default Tabs;
